<template>
  <div v-bind:class="[certificatePage ? 'certificatePage' : '']" class="nav">
    <div v-bind:class="[containerFluidHome ? 'containerFluidHome' : '']" class="container-fluid">
      <div class="apis-navbar">
        <div class="nav-logo" v-bind:class="[hiddenLogo ? 'hiddenLogo' : '']">
          <!--  v-if="has_logo" -->
          <router-link class="d-flex align-items-center" to="/">
            <img :src=" logo.mini_logo ? logo.mini_logo : require('../assets/logo.svg')" class="img-fluid" alt="Logo" />
           <!--  <img :src="require('../assets/logo.png')" class="img-fluid" alt="Logo" /> -->
            <div class="logo-title"></div>
          </router-link>
        </div>
        <div v-bind:class="[isActive ? 'active' : '']" class="nav-links">

          <div v-if="pgLoading" class="navlinks-content">
            <a class="nav-link webkit-animation" style="color:transparent">Accreditation</a>
            <a class="nav-link webkit-animation" style="color:transparent;margin-left: 25px">Programs</a>
            <a class="nav-link webkit-animation" style="color:transparent;margin-left: 25px">Certification</a>
            <a class="nav-link webkit-animation" style="color:transparent;margin-left: 25px">Membership</a>
            <a class="nav-link webkit-animation" style="color:transparent;margin-left: 25px">About</a>
            <a class="nav-link webkit-animation" style="color:transparent;margin-left: 25px">Contact Us</a>
          </div>
          <div v-if="!pgLoading" class="navlinks-content">

            <router-link v-if="(header[0]) ? header[0].status : false" 
                        to="/accreditations" class="nav-link">Accreditation</router-link>
            <router-link v-if="(header[1]) ? header[1].status : false"
                        to="/programs" class="nav-link">Programs</router-link>
            <router-link v-if="(header[8]) ? header[8].status : false"
                        to="/our-certificates" class="nav-link">Certification</router-link>
            <router-link v-if="(header[2]) ? header[2].status : false"
                        to="/memberships" class="nav-link">Membership</router-link>
            <router-link v-if="(header[3]) ? header[3].status : false"
                        to="/about" class="nav-link">About</router-link>
            <router-link v-if="(header[4]) ? header[4].status : false"
                         to="/contact" class="nav-link">Contact Us</router-link>
            
            <router-link v-for="(pg, idy) in pages" :key="'p'+idy"
                      :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                class="nav-link"
                :class="(pg.has_header) ? '' : 'hidden' ">
                {{ pg.title }}
            </router-link>


            <a href="javascript:;" 
                @click="opnPopular(pop.slug)"  
                v-for="(pop, idx) in popularSearch" :key="'s'+idx"
                class="nav-link hidden-sm" >{{ pop.title }}
            </a>
            <router-link :to="{ name: 'myCertificate' }" class="nav-link hidden-sm">
              My Certificate
            </router-link>
            <!--  <a href="https://www.agmep.group/VerifyAIPS.html" target="_blank" class="nav-link hidden-sm">My Certificate</a> -->
            <!-- <router-link to="/i-am-instructor" class="nav-link hidden-sm">I am Instructor</router-link>
            <router-link to="/training-center" class="nav-link hidden-sm">Training Center</router-link>
            <router-link to="/i-have-experience" class="nav-link hidden-sm">I Have Experience</router-link>
            <router-link to="/my-certificate" class="nav-link hidden-sm">My Certificate</router-link>
            <router-link to="/corporate-training" class="nav-link hidden-sm">Corporate Training</router-link> -->
          </div>

          <div v-if="pgLoading" class="hiddenBgSize">
            <div class="footer-links">
              <a class="nav-link webkit-animation" style="color:transparent">Privacy Policy</a>
              <a class="nav-link webkit-animation" style="color:transparent;margin-left: 25px">Events &amp; Conferences</a>
              <a class="nav-link webkit-animation" style="color:transparent;margin-left: 25px">Online Training</a>
            </div>
          </div>
          <div v-if="!pgLoading" class="hiddenBgSize">
            <div class="footer-links">

              <router-link v-if="(header[5]) ? header[5].status : false" 
                          to="/privacy" class="footer-link">Privacy Policy</router-link>
              <router-link v-if="(header[6]) ? header[6].status : false"
                           to="/events" class="footer-link">Events &amp; Conferences</router-link>
              <router-link v-if="(header[7]) ? header[7].status : false"
                           to="/online-training" class="footer-link">Online Training</router-link>

            <router-link v-for="(pg, id2x) in pages" :key="'f'+id2x"
                      :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                class="footer-link"
                :class="(pg.has_footer) ? '' : 'hidden' ">
                {{ pg.title }}
            </router-link>

            </div>
            <Footer :footerNavbar="true" />
          </div>
          
        </div>


        <div class="nav-actions d-flex align-items-center">
          <button
            v-bind:class="[isActive ? 'hiddenAction' : '']"
            type="button"
            name="button"
            class="navbar-action"
          >
            <div v-if="authenticated" class="showDropdown">
              <img :src="(avatar) ? avatar : require('../assets/img/avatar.jpg')" 
                class="img-fluid" alt=""  style="border-radius: 50%" />
              <div class="dropdown-container">
                <router-link to="/me/profile">Profile</router-link>
                <a href="javascript:;" @click="logout()">Logout</a>
              </div>
            </div>
            <router-link v-else to="/login" class="navbar-action">
              <span class="icon-user icon"></span>
            </router-link>
          </button>
          <div v-bind:class="[isActive ? 'hiddenAction' : '']" class="horizontal-divider"></div>
          <button
            v-bind:class="[isActive ? 'hiddenAction' : '']"
            @click="toggleSearch = !toggleSearch"
            class="navbar-action"
          >
            <span class="icon-close icon" v-if="toggleSearch"></span>
            <span class="icon-search icon" v-else></span>
          </button>
          <button
            v-bind:class="[isActive ? 'active' : '']"
            id="menuBar"
            class="menu-bar-a"
            @click="toggleNavbar()"
          >
            <div class="menu-bar">
              <div class="child-bar-1"></div>
              <div class="child-bar-2"></div>
              <div class="child-bar-3"></div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <Search v-if="toggleSearch" />
  </div>
</template>

<style lang="scss" scoped>
  .showDropdown {
    position: relative;
    height: 33px;
    width: 33px;
  }
  .showDropdown img {
    width: 100%;
    height: 100%;
  }
  .showDropdown:after {
    content: "";
    position: absolute;
    top: 32px;
    left: 50%;
    transform: translateX(-50%);
    min-width: 120px;
    height: 16px;
    display: none;
  }
  .dropdown-container {
    position: absolute;
    background: #fff;
    padding: 5px 0;
    z-index: 20;
    min-width: 120px;
    left: 50%;
    transform: translateX(-50%);
    top: 46px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(3, 27, 78, 0.1);
    display: none;
  }
  .showDropdown:hover:after {
    display: block;
  }
  .showDropdown:hover .dropdown-container {
    display: block;
  }
  .dropdown-container a {
    display: block;
    text-align: left;
    padding: 7px 17px;
    line-height: 1;
  }
  .dropdown-container a:hover {
    background: #eee;
  }
  .menu-bar {
    position: relative;
    width: 40px;
    height: 21px;
    display: block !important;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    -ms-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    margin-top: -3px;
    margin-left: 14px;
  }
  .horizontal-divider {
    margin: 0 19px;
  }
  .menu-bar > div {
    position: absolute;
    height: 2px;
    width: 100%;
    border-radius: 0;
    background: #000;
    transition: all 0.3s ease-in-out;
  }
  .menu-bar > div:first-of-type {
    top: 0;
    width: 100%;
  }
  .menu-bar > div:nth-of-type(2) {
    top: 50%;
  }
  .menu-bar > div:last-of-type {
    top: 100%;
  }

  .menu-bar-a.active .menu-bar > div:first-of-type {
    transform: translateY(10px) rotate(50deg);
  }
  .menu-bar-a.active .menu-bar > div:nth-of-type(2) {
    opacity: 0;
  }
  .menu-bar-a.active .menu-bar > div:last-of-type {
    transform: translateY(-11px) rotate(-49deg);
  }
  #menuBar {
    display: none;
  }
  .logo-title {
    font-size: 38px;
    margin-left: 7px;
    font-weight: bold;
    color: #1b1464;
  }
  .containerFluidHome .navlinks-content {
    padding-left: 40px;
  }
  .hiddenLogo {
    display: none;
  }
  .hiddenBgSize {
    display: none;
  }
  .certificatePage {
    display: none;
  }
  .hidden-sm {
    display: none;
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 767.98px) {
    .nav-links {
      position: fixed;
      top: 64px;
      z-index: 20;
      background: #370f76;
      width: 100%;
      left: 0;
      height: calc(100% - 61px);
      flex-wrap: wrap;
      align-items: inherit;
      display: none;
      padding: 0 20px;
      z-index: 1000;
      overflow-y: auto;
    }
    .navlinks-content {
      display: block;
      padding-left: 0 !important;
      min-height: calc(100% - 48px);
    }
    .nav-links.active {
      display: block;
    }
    .nav-link {
      color: #d0d877;
      font-weight: normal;
      font-size: 32px;
      padding-left: 0;
      padding-right: 0;
      display: block;
      width: 100%;
      border-bottom: 1px solid #d0d87740;
    }
    #menuBar {
      display: block;
    }
    .nav {
      padding: 10px 0;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 100;
    }
    .hiddenLogo {
      display: block;
    }
    .hiddenAction {
      display: none;
    }
    .containerFluidHome .nav-links {
      padding: 0 20px;
    }
    .hiddenBgSize {
      display: block;
    }
    .certificatePage {
      display: block;
    }
    .hidden-sm {
      display: block;
    }
    .footer-links {
      padding: 10px 0;
    }
    .footer-links a {
      color: #999;
      font-size: 14px;
      margin-right: 13px;
      display: inline-block;
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .nav-links {
      margin-right: 0;
      padding-left: 0 !important;
    }
    .nav-logo img {
      transform: none;
    }
    .nav-link {
      padding: 0.5rem 0.5rem;
      font-size: 16px;
    }
    .containerFluidHome .nav-logo {
      display: block;
    }
    .containerFluidHome {
      padding: 0 !important;
    }
    .navlinks-content {
      padding-left: 0 !important;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .containerFluidHome .nav-logo {
      display: block;
    }
    .containerFluidHome {
      padding: 0;
    }
    .navlinks-content {
      padding-left: 0 !important;
    }
    .nav-link {
      font-size: 17px;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .containerFluidHome {
      padding: 0;
    }
  }
</style>
<style scoped="">
.hidden { display: none !important }
</style>

<script>
import Search from "./Search.vue";
import Avatar from "./Avatar.vue";
import Footer from "./Footer.vue";
import axios from "axios";
export default {
  name: "Navbar",
  components: {
    Avatar: Avatar,
    Search: Search,
    Footer: Footer,
  },
  props: ["has_logo", "containerFluidHome", "hiddenLogo", "certificatePage"],
  data() {
    return {
      toggleSearch: false,
      isActive: false,
      authenticated: false,
      links: [],
      navbar: [],
      logo: [],
      header: [],

      popularSearch: [],
      pages: [],

      pgLoading: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    toggleNavbar: function () {
      this.isActive = !this.isActive;
    },
    fetchLogo() {
      // Get Navbar Links
      axios
        .get(window.baseURL + "/setting")
        .then((res) => {
          var data = res.data.logo;
          this.logo = data;
          this.header = res.data.header;
        })
        .catch(() => {});
    },


    logout(){
      localStorage.clear();
      this.$router.push({ name: 'login' });
    },

    opnPopular(slug) {
      this.$router.push({ name: "show-popular-search", params:{slug: slug }});
      // refersh
      location.reload();
    },
  },
  created() {
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    if(!localStorage.getItem("avatar")) {
      this.avatar = false;
    } else {
      this.avatar = localStorage.getItem("avatar");
    }

    // Get Navbar Links
    axios
      .get(window.baseURL + "/popularSearch")
      .then((res) => {
        var data = res.data.rows;
        this.popularSearch = res.data.rows;
      })
      .catch(() => {});

    //Get Navbar Links in Big Sizes
    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});

    //Fetch Logo
    this.fetchLogo();
    this.scrollToTop();
  },
};
</script>
